import { PlusIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

import FieldsetContainer from '@/components/shared/FieldsetContainer';
import { Button } from '@/components/ui/daisy';
import useFormList from '@/data/hook/shared/useFormList';
import EvaluationBlockInlineForm, {
  EvaluationBlockInlineFormFields,
} from './EvaluationBlockInlineForm';

type EvaluationBlockFormListProps = {
  onSubmit: (data: EvaluationBlockInlineFormFields) => Promise<void>;
  courseLineId: number;
  isLoading: boolean;
};

export default function EvaluationBlockFormList({
  onSubmit,
  isLoading,
  courseLineId,
}: EvaluationBlockFormListProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.evaluationsTab',
  });
  const { openForms, addForm, removeForm, handleFormSubmit } =
    useFormList<EvaluationBlockInlineFormFields>({ onSubmit });

  return (
    <div className="flex flex-col gap-6">
      {openForms.map(formId => (
        <EvaluationBlockInlineForm
          key={formId}
          onSubmit={handleFormSubmit(formId)}
          onCancel={() => removeForm(formId)}
          isLoading={isLoading}
          courseLineId={courseLineId}
        />
      ))}
      <FieldsetContainer>
        <Button
          size="md"
          onClick={addForm}
          className="bg-base-300"
          disabled={openForms.length >= 1}
        >
          <PlusIcon className="w-4 h-4" />
          {t('addBlock')}
        </Button>
      </FieldsetContainer>
    </div>
  );
}
